import {START_PULLS_LOAD, SET_PULLS_RESULT, NETWORK_ERROR} from './types'

export const INITIAL = 'INITIAL'
export const LOADING = 'LOADING'
export const LOADED = 'LOADED'
export const ERROR = 'ERROR'

const initialState = {
  status: INITIAL,
  pulls: [],
}

export default function(prev_state = initialState, action) {
  const {status} = prev_state
  switch (action.type) {
    case START_PULLS_LOAD: {
      if (![INITIAL, LOADED, ERROR].includes(status)) {
        console.error(`${status}->LOADING should not happen`)
        return prev_state
      }
      return {
        ...prev_state,
        status: LOADING,
      }
    }
    case SET_PULLS_RESULT: {
      const {pulls} = action

      if (status !== LOADING) {
        console.error(`${status}->LOADED should not happen`)
        return prev_state
      }

      return {
        ...prev_state,
        status: LOADED,
        pulls,
      }
    }
    case NETWORK_ERROR: {
      const {error} = action

      if (status !== LOADING) {
        console.error(`${status}->ERROR should not happen`)
        return prev_state
      }

      return {
        ...prev_state,
        status: ERROR,
        error,
      }
    }
    default: {
      return prev_state
    }
  }
}
